<div class="flex flex-col gap-1">
  @if (label()) {
    <label class="text-sm font-medium text-[var(--color-text-secondary)]">
      {{ isRequired() ? label() + '*' : label() }}
    </label>
  }
  <select
    class="w-full px-3 py-2 text-sm border border-[var(--color-border)] rounded-lg bg-[var(--color-bg-primary)] text-[var(--color-text-primary)] outline-none transition-all duration-150 hover:border-[var(--color-text-muted)] focus:border-[var(--color-primary)] focus:shadow-[0_0_0_2px_var(--color-primary-light)] cursor-pointer min-w-[8rem]"
    [formControl]="getFormControl"
    [class.border-[var(--color-text-error)]!]="hasErrorState()"
    [class.bg-[var(--color-bg-error)]!]="hasErrorState()"
    (change)="onSelectionChange($any($event.target).value)"
  >
    <option value="">{{ displayPlaceholder }}</option>
    @for (option of arrayData(); track option) {
      <option [value]="inputSelect().value === '' ? option : getNestedProperty(option, inputSelect().value)">
        {{ translateOptions() ? (getOptionLabel(option) | async) : getOptionLabel(option) }}
      </option>
    }
  </select>
  @if (hasErrorState()) {
    <span class="text-[0.8125rem] text-[var(--color-text-error)] mt-1">{{ getErrorMessage() }}</span>
  }
</div>
